"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _userCanUpdateField = require("../../../../../schema/security/user-can-update-field");
var _userIsSystemAdmin = _interopRequireDefault(require("../../../../../schema/security/user-is-system-admin"));
var _rowConfig = _interopRequireDefault(require("../../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../../core/label"));
var _row = _interopRequireDefault(require("../../../../core/row"));
var _col = _interopRequireDefault(require("../../../../core/col"));
var _selectCode = _interopRequireDefault(require("../../../../core/select-code"));
var _editableField = _interopRequireDefault(require("../../../../core/editable-field"));
var _divisionFeeAdjustments = _interopRequireDefault(require("./division-fee-adjustments"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "Loading...");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, " Base Entry Fee (in pence)");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, " Additional Late Fee (in pence)");
class DivisionFees extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onAddFeeAdjustment", value => {
      this.props.onAddFeeAdjustment(this.props.division.id, value);
    });
  }
  // *******************************************************************************
  // Render
  // *******************************************************************************

  render() {
    const division = this.props.division;
    const competitionID = this.props.competitionID;
    const user = this.props.user;
    const yearID = this.props.yearID;
    if (!this.props.loaded) return _ref;
    if (division.isFreeToEnter) return null;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 7,
        md: 6
      }, {
        sm: 5,
        md: 6
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: (0, _userCanUpdateField.userCanUpdateDivisionField)('entryFee', competitionID, user),
      preparedForEdit: true,
      type: "Integer",
      name: "entryFee",
      value: division.entryFee,
      maxLength: 4,
      onChange: this.props.onChange
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: (0, _userCanUpdateField.userCanUpdateDivisionField)('lateFee', competitionID, user),
      preparedForEdit: true,
      type: "Integer",
      name: "lateFee",
      value: division.lateFee,
      maxLength: 4,
      onChange: this.props.onChange
    }))))), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      xs: 12,
      md: 12,
      lg: 12,
      xl: 7
    }, /*#__PURE__*/_react.default.createElement(_divisionFeeAdjustments.default, {
      divisionFeeAdjustments: division.divisionFeeAdjustments,
      user: user
    })), !division.hasAvailableFeeAdjustments || !(0, _userIsSystemAdmin.default)(user) ? null : /*#__PURE__*/_react.default.createElement(_col.default, {
      xs: 12,
      md: 12,
      lg: 12,
      xl: 5
    }, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "AvailableFeeAdjustments",
      yearID: yearID,
      tierRef: division.tierRef,
      existingFeeAdjustmentRefs: division.divisionFeeAdjustments.map(div => div.feeAdjustmentRef),
      name: "newFeeAdjustment",
      placeholder: "Select FeeAdjustment to Add to this Division",
      onChange: this._onAddFeeAdjustment,
      clearable: false
    }))));
  }
  // ****************************************************************************
  // PartialQuery definition
  // ****************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(DivisionFees, "partials", {
  Division: {
    id: true,
    tierRef: true,
    isFreeToEnter: true,
    entryFee: true,
    lateFee: true,
    hasAvailableFeeAdjustments: true,
    divisionFeeAdjustments: _mergeBqlQueries({
      feeAdjustmentRef: true
    }, _divisionFeeAdjustments.default.partials.DivisionFeeAdjustments)
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(DivisionFees, undefined, (client, props) => ({
  onAddFeeAdjustment(competitionDivisionID, feeAdjustmentRef) {
    return client.update('DivisionFeeAdjustment.create', {
      competitionDivisionID,
      feeAdjustmentRef
    });
  }
}));